var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'mb-1 line-height-initial': _vm.small }},[_c('v-tooltip',{attrs:{"top":"","content-class":"custom-top-tooltip"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-chip',_vm._g(_vm._b({staticClass:"my-auto d-inline-table font-weight-600 text-uppercase justify-center font-10",class:{
          'd-inline mx-2': !_vm.visitList && _vm.small,
          'ml-4 mr-2': !_vm.visitList && !_vm.small,
        },attrs:{"color":_vm.priorityColor,"outlined":"","label":"","small":_vm.small}},'v-chip',attrs,false),on),[_vm._v(" "+_vm._s(_vm.priorityText)+" ")])]}}])},[_c('span',[_vm._v("Priority")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }